import { SITE_URL } from './site';

export const FAVICON_URL =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/0dc5bc4081b05862da3d01553c9c9d93.png';

export interface FaqEntry {
  q: string;
  a: string;
}

export function websiteSchema(): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Basetao Spreadsheet',
    url: SITE_URL,
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://kaspreadsheet.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };
}

export function organizationSchema(): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Basetao Spreadsheet',
    url: SITE_URL,
    logo: FAVICON_URL,
  };
}

export function faqPageSchema(faq: FaqEntry[]): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faq.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
  };
}

export interface ArticleSchemaArgs {
  headline: string;
  description: string;
  image: string;
  url: string;
  datePublished: string;
  dateModified: string;
  author: string;
}

export function articleSchema(args: ArticleSchemaArgs): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: args.headline,
    description: args.description,
    image: args.image,
    url: args.url,
    datePublished: args.datePublished,
    dateModified: args.dateModified,
    author: {
      '@type': 'Organization',
      name: args.author,
    },
    publisher: {
      '@type': 'Organization',
      name: 'Basetao Spreadsheet',
      logo: {
        '@type': 'ImageObject',
        url: FAVICON_URL,
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': args.url,
    },
  };
}

export interface BreadcrumbItem {
  name: string;
  url: string;
}

export function breadcrumbListSchema(items: BreadcrumbItem[]): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}